import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import BaseLayout from "../../layout/BaseLayout";
import {
  getListeAnnee,
  rechercheGrapheMontantPaiement,
  rechercheGrapheNombrePaiement,
} from "../../services/statistique/StatistiqueRequest";
import { getListeServiceEtablissement } from "../../services/tarifs/TarifsRequest";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import {
  getListeElevePaginationOne,
  getListeEleveSearch,
} from "../../services/eleve/EleveRequest";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const navigate = useNavigate();
  const [graphOptions, setGraphOption] = useState({
    options: {
      chart: {
        id: "basic-bar",
        toolbar: {
          show: false,
        },
      },
      dataLabels: { enabled: true },
      xaxis: {
        categories: [],
      },
    },
    series: [
      {
        name: "series-1",
        data: [],
      },
    ],
  });

  const [graphOptions2, setGraphOption2] = useState({
    options: {
      chart: {
        id: "basic-bar",
        toolbar: {
          show: false,
        },
      },
      dataLabels: { enabled: true },
      xaxis: {
        categories: [],
      },
    },
    series: [
      {
        name: "series-2",
        data: [],
      },
    ],
  });
  const [loadingData, setLoadingData] = useState(true);
  const [loadingStat, setLoadingStat] = useState(false);
  const [loadingStat2, setLoadingStat2] = useState(false);
  const [load, setLoad] = useState(false);
  const [load2, setLoad2] = useState(false);
  const [serviceListe, setServiceListe] = useState([]);

  const [periode, setPeriode] = useState("JOUR");
  const [periode2, setPeriode2] = useState("JOUR");
  const [mois, setMois] = useState("");
  const [annee, setAnnee] = useState("");
  const [listeAnnee, setListeAnnee] = useState([]);
  const [service, setService] = useState("");
  const [eleve, setEleve] = useState("");
  const [etablissement, setEtablissement] = useState("");
  const [mois2, setMois2] = useState("");
  const [annee2, setAnnee2] = useState("");
  const [service2, setService2] = useState("");
  const [eleve2, setEleve2] = useState("");
  const [etablissement2, setEtablissement2] = useState("");
  const [canal, setCanal] = useState("");

  const [query, setQuery] = useState("");
  const [query2, setQuery2] = useState("");
  const [eleveListe, setEleveListe] = useState([]);
  const [eleveListe2, setEleveListe2] = useState([]);
  const [delayedQuery, setDelayedQuery] = useState("");
  const [delayedQuery2, setDelayedQuery2] = useState("");
  const [nombreTransaction, setNombreTransaction] = useState("");
  const [montantTransaction, setMontantTransaction] = useState("");

  const [Route, setRoute] = useState("");

  const [open, setOpen] = useState(false);
  let loading = open;

  const [open2, setOpen2] = useState(false);
  let loading2 = open2;

  const date = new Date();
  const currentMonth =
    date.getDate().length !== 2 && date.getMonth().length === 2
      ? `0${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
      : date.getMonth().length !== 2 && date.getDate().length === 2
        ? `${date.getDate()}/0${date.getMonth() + 1}/${date.getFullYear()}`
        : date.getMonth().length !== 2 && date.getDate().length !== 2
          ? `0${date.getDate()}/0${date.getMonth() + 1}/${date.getFullYear()}`
          : `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;

  const listeMois = [
    {
      libelle: "Janvier",
      value: 1,
    },
    {
      libelle: "Février",
      value: 2,
    },
    {
      libelle: "Mars",
      value: 3,
    },
    {
      libelle: "Avril",
      value: 4,
    },
    {
      libelle: "Mai",
      value: 5,
    },
    {
      libelle: "Juin",
      value: 6,
    },
    {
      libelle: "Juillet",
      value: 7,
    },
    {
      libelle: "Août",
      value: 8,
    },
    {
      libelle: "Septembre",
      value: 9,
    },
    {
      libelle: "Octobre",
      value: 10,
    },
    {
      libelle: "Novembre",
      value: 11,
    },
    {
      libelle: "Décembre",
      value: 12,
    },
  ];

  // const getListeDesService = () => {
  //   setLoadingData(true);
  //   getListeServiceEtablissement()
  //     .then((res) => {
  //       setLoadingData(false);
  //       setServiceListe(res.data.donnee);
  //     })
  //     .catch((err) => {
  //       setLoadingData(false);
  //       console.log("api error", err);
  //     });
  // };

  const getListeDesAnnees = () => {
    getListeAnnee()
      .then((res) => {
        setListeAnnee(res.data.donnee);
      })
      .catch((err) => {
        console.log("api error", err);
      });
  };

  const fetchGraphData = () => {
    setLoadingStat(true);

    const parameter = {
      annee: annee,
      canal: "",
      etablissementId: etablissement,
      mois: mois,
      periode: periode,
      serviceId: service,
      eleveId: eleve ? eleve.id : "",
    };

    rechercheGrapheNombrePaiement(parameter)
      .then((res) => {
        setLoadingStat(false);
        const graph = {
          options: {
            chart: {
              id: "basic-bar",
              toolbar: {
                show: false,
              },
            },
            dataLabels: { enabled: true },
            xaxis: {
              categories: res.data.donnee.categories,
            },
          },
          series: [
            {
              name: "Nombre de paiement",
              data: res.data.donnee.series,
            },
          ],
        };

        setGraphOption(graph);
        setNombreTransaction(res.data.donnee.nombretotalpaiements);
      })
      .catch((err) => {
        setLoadingStat(false);
        console.log("api error", err);
        if (err.response && err.response.status === 401) {
          localStorage.removeItem("momo4scoohclient");
          navigate("/login");
        }
      });
  };

  const fetchGraphData2 = () => {
    setLoadingStat2(true);

    const parameter = {
      annee: annee2,
      canal: canal,
      etablissementId: etablissement2,
      mois: mois2,
      periode: periode2,
      serviceId: service2,
      eleveId: eleve2 ? eleve2.id : "",
    };

    rechercheGrapheMontantPaiement(parameter)
      .then((res) => {
        setLoadingStat2(false);
        const graph = {
          options: {
            chart: {
              id: "basic-bar",
              toolbar: {
                show: false,
              },
            },
            dataLabels: { enabled: true },
            xaxis: {
              categories: res.data.donnee.categories,
            },
          },
          series: [
            {
              name: "Montant des paiements",
              data: res.data.donnee.series,
            },
          ],
        };

        setGraphOption2(graph);
        setMontantTransaction(res.data.donnee.montantpaiements);
      })
      .catch((err) => {
        setLoadingStat2(false);
        console.log("api error", err);
      });
  };

  // useeffect pour récupérer la liste des utilisateur à la recherche
  // autocomplete 1
  useEffect(() => {
    let timeoutId;
    setEleveListe([]);
    setLoad(true);

    if (query === "") {
      timeoutId = setTimeout(() => {
        getListeEleveSearch(query)
          .then((res) => {
            setLoad(false);
            setEleveListe(res.data.donnee);
          })
          .catch((err) => {
            console.log("api error", err);
          });
      }, 1000);
    } else {
      timeoutId = setTimeout(() => {
        getListeEleveSearch(query)
          .then((res) => {
            setLoad(false);
            setEleveListe(res.data.donnee);
          })
          .catch((err) => {
            console.log("api error", err);
          });
      }, 1000);
    }

    return () => clearTimeout(timeoutId);
  }, [query]);

  // useeffect pour récupérer la liste des utilisateur à la recherche
  // autocomplete 2
  useEffect(() => {
    let timeoutId;
    setEleveListe2([]);
    setLoad2(true);

    if (query2 === "") {
      timeoutId = setTimeout(() => {
        getListeEleveSearch(query2)
          .then((res) => {
            setLoad2(false);
            setEleveListe2(res.data.donnee);
          })
          .catch((err) => {
            console.log("api error", err);
          });
      }, 1000);
    } else {
      timeoutId = setTimeout(() => {
        getListeEleveSearch(query2)
          .then((res) => {
            setLoad2(false);
            setEleveListe2(res.data.donnee);
          })
          .catch((err) => {
            console.log("api error", err);
          });
      }, 1000);
    }

    return () => clearTimeout(timeoutId);
  }, [query2]);

  useEffect(() => {
    const date = new Date();
    setAnnee(date.getFullYear());
    setAnnee2(date.getFullYear());
    setMois(date.getMonth() + 1);
    setMois2(date.getMonth() + 1);

    // getListeDesService();
    getListeEleveSearch("")
      .then((res) => {
        setEleveListe(res.data.donnee);
      })
      .catch((err) => {
        console.log("api error", err);
      });
    getListeDesAnnees();
    fetchGraphData();
    fetchGraphData2();
  }, []);

  useEffect(() => {
    const routeOfEntite = localStorage.getItem("entiteRoute");
    setRoute(routeOfEntite);
  }, []);

  return (
    <BaseLayout>
      <div className="w-11/12 mx-auto pt-28 pb-24">
        <h1 className="text-4xl font-bold">Tableau de bord</h1>

        <div className="mt-12 relative bg-white rounded-lg p-5">
          <div className="flex items-center justify-between gap-x-6">
            <p className="text-xl text-sky-600 font-bold mt-3">
              Nombre de transaction:{" "}
              <span className="text-black">
                {nombreTransaction}
              </span>{" "}
            </p>
            <div className="flex items-end justify-end gap-x-4">
              <div>
                <label className="label">
                  <span className="label-text">Période</span>
                </label>
                <select
                  disabled={loadingStat}
                  value={periode}
                  onChange={(e) => setPeriode(e.target.value)}
                  className="select select-bordered select-sm w-fit"
                >
                  <option value="JOUR">Jours</option>
                  <option value="MOIS">Mois</option>
                </select>
              </div>
              {periode === "JOUR" ? (
                <>
                  <div>
                    <label className="label">
                      <span className="label-text">Mois</span>
                    </label>
                    <select
                      disabled={loadingStat}
                      value={mois}
                      onChange={(e) => setMois(e.target.value)}
                      className="w-20 select select-bordered select-sm"
                    >
                      <option value="" disabled selected>
                        Choisir un mois
                      </option>
                      {listeMois.map((item, index) => (
                        <option value={item.value} key={index}>
                          {item.libelle}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="label">
                      <span className="label-text">Année</span>
                    </label>
                    <select
                      disabled={loadingStat}
                      value={annee}
                      onChange={(e) => setAnnee(e.target.value)}
                      className="w-20 select select-bordered select-sm"
                    >
                      <option value="" disabled selected>
                        Choisir une année
                      </option>
                      {listeAnnee.map((item) => (
                        <option value={item} key={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              ) : null}
              {periode === "MOIS" ? (
                <div>
                  <label className="label">
                    <span className="label-text">Année</span>
                  </label>
                  <select
                    disabled={loadingStat}
                    value={annee}
                    onChange={(e) => setAnnee(e.target.value)}
                    className="w-20 select select-bordered select-sm"
                  >
                    <option value="" disabled selected>
                      Choisir une année
                    </option>
                    {listeAnnee.map((item) => (
                      <option value={item} key={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              ) : null}
              <button
                disabled={loadingStat}
                className="bg-momo-blue text-white px-4 py-2 rounded-md"
                onClick={fetchGraphData}
              >
                Rechercher
              </button>
            </div>
          </div>
          <div className="mt-10">
            <p className="font-bold">Nombre de paiement</p>
          </div>
          <Chart
            options={graphOptions.options}
            series={graphOptions.series}
            type="bar"
            width="100%"
            height="350px"
          />
          <p className="font-bold text-center">Période</p>
        </div>

        <div className="mt-12 relative bg-white rounded-lg p-5">
          <div className="flex items-center justify-between gap-x-6">
            <p className="text-xl text-sky-600 font-bold mt-3">
              Montant total:{" "}
              <span className="text-black">{montantTransaction} FCFA</span>{" "}
            </p>
            <div className="flex items-end justify-end gap-x-4">
              <div>
                <label className="label">
                  <span className="label-text">Période</span>
                </label>
                <select
                  disabled={loadingStat2}
                  className="select select-bordered select-sm w-fit"
                  value={periode2}
                  onChange={(e) => setPeriode2(e.target.value)}
                >
                  <option value="JOUR">Jours</option>
                  <option value="MOIS">Mois</option>
                </select>
              </div>
              {periode2 === "JOUR" ? (
                <>
                  <div>
                    <label className="label">
                      <span className="label-text">Mois</span>
                    </label>
                    <select
                      disabled={loadingStat2}
                      value={mois2}
                      onChange={(e) => setMois2(e.target.value)}
                      className="w-20 select select-bordered select-sm"
                    >
                      <option value="" disabled selected>
                        Choisir un mois
                      </option>
                      {listeMois.map((item, index) => (
                        <option value={item.value} key={index}>
                          {item.libelle}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="label">
                      <span className="label-text">Année</span>
                    </label>
                    <select
                      disabled={loadingStat2}
                      value={annee2}
                      onChange={(e) => setAnnee2(e.target.value)}
                      className="w-20 select select-bordered select-sm"
                    >
                      <option disabled selected>
                        Choisir une année
                      </option>
                      {listeAnnee.map((item) => (
                        <option value={item} key={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              ) : null}
              {periode2 === "MOIS" ? (
                <div>
                  <label className="label">
                    <span className="label-text">Année</span>
                  </label>
                  <select
                    disabled={loadingStat2}
                    value={annee2}
                    onChange={(e) => setAnnee2(e.target.value)}
                    className="w-20 select select-bordered select-sm"
                  >
                    <option value="" disabled selected>
                      Choisir une année
                    </option>
                    {listeAnnee.map((item) => (
                      <option value={item} key={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              ) : null}
              {/* <div>
              <label className="label">
                <span className="label-text">Canal</span>
              </label>
              <select
                disabled={loadingStat2}
                value={canal}
                onChange={(e) => setCanal(e.target.value)}
                className="select select-bordered select-sm"
              >
                <option value="" disabled selected>
                  Choisir un canal
                </option>
                <option value="">Tous</option>
                <option value="ORANGE_MONEY">Orange money</option>
                <option value="MOOV_MONEY">Moov money</option>
                <option value="WAVE">Wave money</option>
                <option value="ESPECE">Espèce</option>
                <option value="AUTRE">Autres</option>
              </select>
            </div> */}

              <div>
                <label className="label">
                  <span className="label-text">Service</span>
                </label>
                <select
                  disabled={loadingStat2}
                  value={service2}
                  onChange={(e) => setService2(e.target.value)}
                  className="select select-bordered select-sm"
                >
                  <option value="" disabled selected>
                    Choisir un service
                  </option>
                  <option value="">Tous</option>
                  {serviceListe.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item.designation}
                    </option>
                  ))}
                </select>
              </div>

              {Route && Route === "Clinique" ? null : (
                <Autocomplete
                  id="asynchronous-demo"
                  sx={{ width: 160 }}
                  open={open2}
                  onOpen={() => {
                    setOpen2(true);
                  }}
                  onClose={() => {
                    setOpen2(false);
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option.nom === value.nom
                  }
                  filterOptions={(x) => x}
                  getOptionLabel={(option) => `${option.nom} ${option.prenoms}`}
                  options={eleveListe2}
                  onChange={(event, newValue) => {
                    setEleve2(newValue && newValue.nom ? newValue : "");
                    setQuery2(
                      newValue && newValue.nom
                        ? `${newValue.nom} ${newValue.prenoms}`
                        : ""
                    );
                  }}
                  inputValue={
                    eleve2 && eleve2.nom
                      ? `${eleve2.nom} ${eleve2.prenoms}`
                      : query2
                  }
                  loading={load2}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Elève"
                      onChange={(e) => setQuery2(e.target.value)}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {load2 ? (
                              <div className="mr-8 mt-1">
                                <CircularProgress color="inherit" size={16} />
                              </div>
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              )}

              <button
                disabled={loadingStat2}
                className="bg-momo-blue text-white px-4 py-2 rounded-md"
                onClick={fetchGraphData2}
              >
                Rechercher
              </button>
            </div>
          </div>

          <div className="mt-10">
            <p className="font-bold">Montant des paiements</p>
          </div>
          <Chart
            options={graphOptions2.options}
            series={graphOptions2.series}
            type="bar"
            width="100%"
            height="350px"
          />
          <p className="font-bold text-center">Période</p>
        </div>
      </div>
    </BaseLayout>
  );
};

export default Dashboard;
